import { CountryCode } from "./country-code.js";
//#region src/domain/i18n/document-type.ts
var DocumentType = /* @__PURE__ */ function(DocumentType) {
	DocumentType["DPI"] = "DPI";
	return DocumentType;
}({});
var DocumentTypeByCountry = {
	[CountryCode.GT]: "DPI",
	[CountryCode.DO]: "",
	[CountryCode.HN]: "",
	[CountryCode.PE]: ""
};
//#endregion
export { DocumentType, DocumentTypeByCountry };

//# sourceMappingURL=document-type.js.map